import { Component, input } from '@angular/core';
import { Command, TranslatedCommandResultEntry } from '@app/shared/quick-commands';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-quick-command-name',
  standalone: true,
  imports: [SharedModule, TranslateModule],
  templateUrl: './quick-command-name.component.html',
  styles: ``,
  host: {
    class: 'quick-commands__result-name',
  },
})
export class QuickCommandNameComponent {
  command = input.required<Command>();
  group = input<string>();
  highlight = input<boolean>(true);
  query = input.required<string>();
  result = input.required<TranslatedCommandResultEntry>();
}
